import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-0" }

export function render(_ctx, _cache) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_Message = _resolveComponent("Message")
  const _component_Button = _resolveComponent("Button")
  const _component_Toast = _resolveComponent("Toast")
  const _directive_keyfilter = _resolveDirective("keyfilter")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-center text-3xl my-3" }, "ลืมรหัสผ่าน", -1 /* HOISTED */)),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_IftaLabel, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_InputText, {
              id: "register_phone",
              modelValue: _ctx.form.phone.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.phone.value) = $event)),
              inputmode: "tel",
              maxlength: "10",
              invalid: _ctx.form.phone.invalid,
              class: "w-full",
              autofocus: "",
              "aria-autocomplete": "none"
            }, null, 8 /* PROPS */, ["modelValue", "invalid"]), [
              [
                _directive_keyfilter,
                void 0,
                void 0,
                { int: true }
              ]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("label", { for: "register_phone" }, "เบอร์โทรศัพท์", -1 /* HOISTED */))
          ]),
          _: 1 /* STABLE */,
          __: [2]
        }),
        (_ctx.form.phone.invalid)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              size: "small",
              severity: "secondary",
              variant: "simple",
              class: "text-red-500! mt-0.5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.form.phone.msgErr), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_Button, {
        label: "ส่ง",
        type: "submit",
        class: "min-w-20 mt-5",
        loading: _ctx.form.btn.loading
      }, null, 8 /* PROPS */, ["loading"])
    ], 32 /* NEED_HYDRATION */),
    _createVNode(_component_Toast)
  ]))
}